import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import {
  fetchNewDependents,
  FetchNewDependentsResponse,
} from 'apis/pretaxDependent';

export type IPretaxDependents = FetchNewDependentsResponse['dependents'][0];

const getPretaxV2Dependents = async () => {
  const {
    data: { dependents },
  } = await fetchNewDependents();
  return { pretax_dependents: dependents };
};

const useQueryPretaxV2Dependents = ({
  is_pretax_enabled,
  onError,
}: {
  is_pretax_enabled: boolean;
  onError?: (e: AxiosError) => void;
}) => {
  const {
    data,
    isLoading: is_loading,
    isFetching: is_fetching,
  } = useQuery(['getPretaxV2Dependents'], () => getPretaxV2Dependents(), {
    enabled: !!is_pretax_enabled,
    onError,
  });

  return {
    data,
    is_loading,
    is_fetching,
  };
};

export default useQueryPretaxV2Dependents;
